import { render, staticRenderFns } from "./MoldTest.vue?vue&type=template&id=92c2047c&"
import script from "./MoldTest.vue?vue&type=script&lang=js&"
export * from "./MoldTest.vue?vue&type=script&lang=js&"
import style0 from "./MoldTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports